export const isExperimentReportDisabled = (isRMLite, selectedNodes) => {
  return (
    isRMLite ||
    !selectedNodes?.length ||
    !selectedNodes.every((node) => node.type === 'Experiment')
  );
};
